var render, staticRenderFns
import script from "./ScoreCardGhostLoader.vue?vue&type=script&lang=tsx"
export * from "./ScoreCardGhostLoader.vue?vue&type=script&lang=tsx"
import style0 from "./ScoreCardGhostLoader.vue?vue&type=style&index=0&id=192fef80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192fef80",
  null
  
)

export default component.exports